import { render, staticRenderFns } from "./teacherClass.vue?vue&type=template&id=613fc204&"
import script from "./teacherClass.vue?vue&type=script&lang=js&"
export * from "./teacherClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports